<section class="catalog-shell" [attr.lang]="language()" aria-label="Public products catalog">
  <header class="catalog-header">
    <h1>{{ t('title') }}</h1>
    <p>{{ t('subtitle') }}</p>

    @if (categoryOptions().length > 0) {
      <section class="category-filter-wrap" [attr.aria-label]="t('filterLabel')">
        <div class="category-filter-head">
          <span>{{ t('filterLabel') }}</span>
          <div class="filter-head-actions">
            @if (selectedCategoryIDs().length > 0) {
              <button type="button" class="clear-filter-btn" (click)="clearCategoryFilters()">{{ t('clearFilters') }}</button>
            }
            <button
              type="button"
              class="toggle-filter-btn"
              [attr.aria-label]="categoryFilterOpen() ? t('hideFilters') : t('showFilters')"
              [attr.title]="categoryFilterOpen() ? t('hideFilters') : t('showFilters')"
              (click)="toggleCategoryFilterPanel()"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M3 6h18"></path>
                <path d="M6 12h12"></path>
                <path d="M10 18h4"></path>
              </svg>
            </button>
          </div>
        </div>

        @if (categoryFilterOpen()) {
          <div class="category-chip-grid">
            @for (category of categoryOptions(); track category.id) {
              <button
                type="button"
                class="category-chip"
                [class.active]="isCategorySelected(category.id)"
                [disabled]="categoryLoading()"
                (click)="toggleCategoryFilter(category.id)"
              >
                {{ categoryName(category) }}
              </button>
            }
          </div>
        }
      </section>
    }
  </header>

  @if (error()) {
    <p class="catalog-error">{{ error() }}</p>
  }

  @if (categoryLoading()) {
    <p class="catalog-state">{{ t('loading') }}</p>
  } @else if (loading() && products().length === 0) {
    <p class="catalog-state">{{ t('loading') }}</p>
  } @else if (!loading() && products().length === 0) {
    <p class="catalog-state">{{ t('empty') }}</p>
  } @else {
    <div class="tiles-grid">
      @for (product of visibleProducts(); track trackByProductID($index, product)) {
        <article class="tile-card">
          <a [routerLink]="['/products', product.id]" class="tile-image-wrap" [attr.aria-label]="productName(product)">
            <img
              class="tile-image"
              [src]="imageURL(product)"
              [alt]="productName(product)"
              loading="lazy"
              decoding="async"
            />
          </a>

          <div class="tile-body">
            <h2>{{ productName(product) }}</h2>
            <p class="tile-description">{{ productDescription(product) }}</p>

            <div class="tile-categories">
              @for (category of product.categories; track category.id) {
                <span>{{ categoryName(category) }}</span>
              }
            </div>

            <a class="details-link" [routerLink]="['/products', product.id]">{{ t('details') }}</a>
          </div>
        </article>
      }
    </div>

    @if (canShowMore()) {
      <div class="show-more-wrap">
        <button type="button" (click)="showMore()">{{ t('showMore') }}</button>
      </div>
    }
  }
</section>
